import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import { unregister } from "./serviceWorker";
import Store from "./store";

import "./index.css";

createRoot(document.getElementById("root")).render(
    <Provider store={Store}>
        <App />
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

unregister();
